<template>
  <div
    :id="id"
    :key="id"
    class="modal"
    tabindex="-1"
    role="dialog"
    style="padding-right: 16px; display: block"
  >
    <div
      class="modal-mask"
      @click.self="$emit('crewListModalClose', flightCrewList)"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Crew List</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeCrewListModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-bordered-gap">
                <thead>
                  <tr>
                    <th class="position-sticky">
                      <div class="border-right">Position/Crew</div>
                    </th>
                    <th>Employee ID</th>
                    <th>Nat</th>
                    <th>Sex</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fItem in flightCrewList" :key="fItem.employeeNo">
                    <td class="position-sticky">
                      <div class="border-right">
                        <div class="d-flex justify-content-between">
                          <div class="text-nowrap position-custom-width">
                            <span class="badge badge-secondary">{{
                              fItem.position
                            }}</span>
                          </div>
                          <div class="crew-custom-width">
                            <div class="text-grey">{{ fItem.cName }}</div>
                            <div>{{ fItem.eName }}</div>
                            <div class="text-grey">
                              {{ fItem.shortName }}<br />{{
                                fItem.positionType
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>{{ fItem.employeeNo }}</td>
                    <td>{{ fItem.nat }}</td>
                    <td>{{ fItem.sex }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    id: { type: String, default: "modal-dialog" },
    currentMission: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    crewList: []
  }),
  created() {
    this.getFlightCrewListData();
  },
  computed: {
    ...mapGetters(["flightCrewList"])
  },
  methods: {
    ...mapActions(["getFlightCrewList"]),
    getFlightCrewListData() {
      let emplEmail = this.$store.getters.impersonateMail
        ? this.$store.getters.impersonateMail
        : null;
      const axiosData = {
        fltNo:
          this.currentMission.subActvName.replaceAll(/[a-zA-Z]/gi, "") ||
          this.currentMission.flightNumber,
        fltFrom: this.currentMission.fromAirp,
        fltTo: this.currentMission.toAirp,
        lclFltDate: this.$moment(this.currentMission.subStartDate).format(
          "YYYY-MM-DD"
        ),
        suffixCode: this.currentMission.suffixCode,
        carrCd: this.currentMission.carrCode
      };
      if (emplEmail) {
        axiosData.emplEmail = emplEmail;
      }

      this.getFlightCrewList(axiosData);
    },
    closeCrewListModal() {
      this.flightCrewList.splice(0, this.flightCrewList.length);
      this.$emit("crewListModalClose");
    }
  }
};
</script>

<style lang="scss" scoped>
.position-custom-width {
  width: 20%;
  @media (max-width: 996px) {
    width: 45%;
  }
}
.crew-custom-width {
  width: 70%;
}

.table td,
.table th {
  vertical-align: top;
}
</style>
